import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
  @Input() menuIsOpen: boolean;

  @Input() phoneNumber: string;

  @Output() clickedCheckPrices = new EventEmitter();
  @Output() clickedHeaderItem = new EventEmitter();
  @Output() clickedMenuItem = new EventEmitter();
  @Output() clickedMouraFacilBrand = new EventEmitter();
  @Output() clickedPhone = new EventEmitter();
  @Output() menuToggled = new EventEmitter();

  constructor() {
    this.menuIsOpen = false;

    this.phoneNumber = '';
  }

  public hideMenu(): void {
    this.menuToggled.emit(false);
  }

  public toggleMenu(): void {
    this.menuToggled.emit(!this.menuIsOpen);
  }
}
